var _style, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTypeSubtask(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 16 16",
    style: {
      enableBackground: "new 0 0 16 16"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill-rule:evenodd;clip-rule:evenodd;fill:#51ACE1;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M12.9,0.9h-10c-1.1,0-2,0.9-2,2v10c0,1.1,0.9,2,2,2h10c1.1,0,2-0.9,2-2v-10C14.9,1.8,14,0.9,12.9,0.9z  M12.4,11.1c0,0.7-0.6,1.3-1.3,1.3H7.7c-0.7,0-1.3-0.6-1.3-1.3V9.4H4.7C4,9.4,3.4,8.8,3.4,8.1V4.7C3.4,4,4,3.4,4.7,3.4h3.4 c0.7,0,1.3,0.6,1.3,1.3v1.7h1.7c0.7,0,1.3,0.6,1.3,1.3V11.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M8.1,4.4H4.7c-0.2,0-0.3,0.1-0.3,0.3v3.4c0,0.2,0.1,0.3,0.3,0.3h1.7V7.7C6.4,7,7,6.4,7.7,6.4h0.7V4.7 C8.4,4.5,8.3,4.4,8.1,4.4z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTypeSubtask);
export default __webpack_public_path__ + "static/media/type_subtask.f8c324eabf116c28741b72c9fb9489da.svg";
export { ForwardRef as ReactComponent };